export interface UserRole {
  id: string;
  name: string;
  level: number;
}

interface TokenPayload {
  userId?: string;
  email?: string;
  roles?: UserRole[];
  iat?: number;
  exp?: number;
}

/**
 * Get JWT token from localStorage
 */
const getToken = (): string | null => {
  return localStorage.getItem('authToken');
};

/**
 * Decode JWT payload
 */
const getTokenPayload = (): TokenPayload | null => {
  const token = getToken();

  if (!token) {
    return null;
  }

  try {
    const payload = token.split('.')[1];

    if (!payload) {
      return null;
    }

    return JSON.parse(atob(payload));
  } catch (error) {
    console.error('Failed to decode JWT token:', error);
    return null;
  }
};

/**
 * Get all roles of the logged-in user
 */
export const getUserRoles = (): string[] => {
  const payload = getTokenPayload();

  if (!payload?.roles) {
    return [];
  }

  return payload.roles
    .map((role) => role.name?.trim().toLowerCase())
    .filter(Boolean);
};

/**
 * Check whether user has a specific role
 */
export const hasRole = (roleName: string): boolean => {
  const userRoles = getUserRoles();

  return userRoles.includes(roleName.trim().toLowerCase());
};

/**
 * Check whether user has at least one of the given roles
 */
export const hasAnyRole = (roleNames: string[]): boolean => {
  const userRoles = getUserRoles();

  return roleNames.some((role) =>
    userRoles.includes(role.trim().toLowerCase())
  );
};